var _path, _line, _line2, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRootTorque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6543 23.9687C18.7819 23.9896 18.9043 24 19.0266 24C19.9681 24 20.766 23.3419 20.9894 22.4384C21.7766 19.2317 24 11.5649 24 9.58026C24 7.0525 21.9096 5 19.3351 5C18.6809 5 18.0585 5.13057 17.4947 5.37081C17.0213 5.56927 16.5106 5.67372 16 5.67372C15.4894 5.67372 14.9787 5.57449 14.5053 5.37081C13.9415 5.13057 13.3191 5 12.6649 5C10.0904 5 8 7.0525 8 9.58026C8 11.3194 10.2021 19.2317 10.9734 22.4384C11.1915 23.3419 11.9894 24 12.9362 24C13.0585 24 13.1862 23.9896 13.3138 23.9634C14.2713 23.7859 14.9362 22.9241 14.9362 21.9684V19.7905C14.9362 18.9601 15.4043 18.5006 15.984 18.5006C16.5638 18.5006 17.0319 18.9601 17.0319 19.5294V21.9684C17.0319 22.9241 17.6968 23.7911 18.6596 23.9687H18.6543Z",
    fill: "#70A4D4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.424,
    y1: 5.265,
    x2: 6.424,
    y2: 21.265,
    stroke: "#1A1A1A",
    strokeDasharray: "2 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 18.868,
    y2: -0.5,
    transform: "matrix(-0.529999 -0.847998 -0.847998 0.529999 26 21)",
    stroke: "#1A1A1A",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22L6.7315 27.727L11.3255 24.23L6 22ZM26 22L20.8973 24.7011L25.7879 27.7696L26 22ZM8.41382 25.9715C10.1118 27.3268 12.69 28.5 16.4999 28.5V27.5C12.9129 27.5 10.5555 26.4014 9.03762 25.19L8.41382 25.9715ZM16.4999 28.5C20.0783 28.5 22.4176 27.4644 23.9302 26.1943L23.2871 25.4285C21.9755 26.5298 19.8717 27.5 16.4999 27.5V28.5Z",
    fill: "#1A1A1A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 5.5,
    r: 1.5,
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRootTorque);
export default __webpack_public_path__ + "static/media/Icon_Root_Torque.b267bd96ca605f2176b9d112e73545a3.svg";
export { ForwardRef as ReactComponent };